import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GlobalLoaderService } from '../../../core/services/global-loader.service';

@Component({
    selector: 'dk-global-loader',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './dk-global-loader.component.html',
    styleUrl: './dk-global-loader.component.scss',
})
export class DkGlobalLoaderComponent {
    readonly loader = inject(GlobalLoaderService);
}
